export default __webpack_public_path__ + "static/media/telegramDesk.8bb2177d.svg";